export const isPinValid = (pin: string) => pin.length === 6;
export const arePinsEqual = (firstPin: string, secondPin: string) =>
  firstPin === secondPin;
